<template>
	<ModalFormCard :action="action" class="modal-default">
		<template #title>{{ showCreate ? 'Create contact' : 'Edit contact' }}</template>

		<template #default="{ saving, errors }">
            <InputDropdownDatePicker
                class="h-14 w-full mr-4"
                inputClass="text-17 !h-14"
                ref="launchDate"
                name="launch_date_at"
                placeholder="Select launch date"
                :min="2"
                :max="30"
                :value="launchDate"
                @change="setTheMonth"
            />

            <InputCheckbox name="happy" value="1" class="mt-8">
                <p class="pl-2 text-grey-900 text-14">
                    I’m happy for you to take payments on the {{ ofTheMonth }} of each month. If you want payments to be taken on a different day, please change your launch date.
                </p>
            </InputCheckbox>

            <div class="modal-buttons">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Set launch date
				</ButtonSaving>
			</div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from "~/mixins/modal.js";

export default {
	mixins: [Modal],

    data() {
        return {
            action: '/onboarding/' + this.editingModel.id + '/step-5',
            ofTheMonth: null,
            launchDate: null,
        }
    },

    created() {
        console.log(this.editingModel.launch_date_at, this.$moment(this.editingModel.launch_date_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'))
        let value = this.$moment().add(2, 'd').format('DD/MM/YYYY')
        if (this.editingModel.launch_date_at != null) {
            value = this.$moment(this.editingModel.launch_date_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
        }

        console.log(value)

        this.setTheMonth(value, 'DD/MM/YYYY')
    },

    methods: {
        setTheMonth(value, format) {
            this.launchDate = this.$moment(value, format).format()
            this.ofTheMonth = this.$moment(value, format).format('Do')
        },
    }
}
</script>